import Vue from 'vue'
import Router from 'vue-router'

// Users
const Home = () => import('@/views/home/Home')
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')
const Profile = () => import('@/views/users/Profile')
const TheContainer = () => import('@/containers/TheContainer')
const Dashboard = () => import('@/views/Dashboard')
const Login = () => import('@/views/account/Login')
const Register = () => import('@/views/account/Register')
const Reset = () => import('@/views/account/Reset')
const Page404 = () => import('@/views/pages/Page404')
const Colors = () => import('@/views/theme/Colors')
const PUser = () => import('@/views/pusers/PUser')
const Verify = () => import('@/views/account/Verify')
const Check = () => import('@/views/account/Check')
const Formation = () => import('@/views/formation/Formation')
const Formations = () => import('@/views/formation/Formations')
const Lessons = () => import('@/views/formation/Lessons')
const Lesson = () => import('@/views/formation/Lesson')
const Exercises = () => import('@/views/formation/Exercises')
const Exercise = () => import('@/views/formation/Exercise')
const Formacao = () => import('@/views/formacao/Formacao')
const Aula = () => import('@/views/formacao/Aula')
const ExercisesAnswers = () => import('@/views/exercises_answers/List')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  //mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      //redirect: '/home',
      component: Home,
    },
    {
      path: '/',
      //redirect: '/dashboard',
      name: 'Dashboard',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'users',
          meta: {
            label: 'Usuários'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: ':tab?',
              name: 'Users',
              meta:{
                label: 'Lista'
              },
              component: Users
            },
            {
              path: 'edit/:id',
              meta: {
                label: 'Usuário'
              },
              name: 'User',
              component: User
            },
            {
              path: 'profile',
              meta: {
                label: 'Meus dados'
              },
              name: 'Profile',
              component: Profile
            }
          ]
        },
        {
          path: 'pusers',
          meta: {
            label: 'Pré-usuários'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'edit/:id',
              meta: {
                label: 'Cadastro'
              },
              name: 'PUser',
              component: PUser
            }
          ]
        },
        {
          path: 'exercises',
          component: ExercisesAnswers
        },
        {
          path: 'formations',
          meta: {
            label: 'Formações'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'Formações',
              meta:{
                label: 'Lista'
              },
              component: Formations
            },
            {
              path: 'edit/:id',
              meta: {
                label: 'Formação'
              },
              name: 'Edição',
              component: Formation
            },
            {
              path: 'lessons/:id',
              meta: {
                label: 'Aulas'
              },
              name: 'lessons',
              component: Lessons
            },
            {
              path: ':formation/lessons/edit/:id',
              meta: {
                label: 'Aula'
              },
              name: 'lessons',
              component: Lesson
            },

            {
              path: 'exercises/:id',
              meta: {
                label: 'Exercícios'
              },
              name: 'exercises',
              component: Exercises
            },
            {
              path: ':lessons/exercises/edit/:id',
              meta: {
                label: 'Exercício'
              },
              name: 'exercise',
              component: Exercise
            }

          ]
        },
        {
          path: 'formacao/:id',
          meta: {
            label: 'Formação'
          },
          component: Formacao
        },
        {
          path: 'aula/:formacao/:aula',
          meta: {
            label: 'Aula'
          },
          component: Aula
        },
      ],
    },
    {
      path: '/',
      redirect: '/pages/404',
      name: 'Account',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          redirect: '/'
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        },
        {
          path: 'verify',
          name: 'Verify',
          component: Verify
        },
        {
          path: 'check/:id?/:hash?',
          name: 'Check',
          component: Check
        },
        {
          path: 'reset/:token',
          name: 'Reset',
          component: Reset
        },
      ]
    }
  ]
}

/*
function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'theme',
          redirect: '/theme/colors',
          name: 'Theme',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'colors',
              name: 'Colors',
              component: Colors
            },
            {
              path: 'typography',
              name: 'Typography',
              component: Typography
            }
          ]
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },
        {
          path: 'users',
          meta: {
            label: 'Users'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'Users',
              component: Users
            },
            {
              path: ':id',
              meta: {
                label: 'User Details'
              },
              name: 'User',
              component: User
            }
          ]
        },
        {
          path: 'base',
          redirect: '/base/cards',
          name: 'Base',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'cards',
              name: 'Cards',
              component: Cards
            },
            {
              path: 'forms',
              name: 'Forms',
              component: Forms
            },
            {
              path: 'switches',
              name: 'Switches',
              component: Switches
            },
            {
              path: 'tables',
              name: 'Tables',
              component: Tables
            },
            {
              path: 'tabs',
              name: 'Tabs',
              component: Tabs
            },
            {
              path: 'breadcrumbs',
              name: 'Breadcrumbs',
              component: Breadcrumbs
            },
            {
              path: 'carousels',
              name: 'Carousels',
              component: Carousels
            },
            {
              path: 'collapses',
              name: 'Collapses',
              component: Collapses
            },
            {
              path: 'jumbotrons',
              name: 'Jumbotrons',
              component: Jumbotrons
            },
            {
              path: 'list-groups',
              name: 'List Groups',
              component: ListGroups
            },
            {
              path: 'navs',
              name: 'Navs',
              component: Navs
            },
            {
              path: 'navbars',
              name: 'Navbars',
              component: Navbars
            },
            {
              path: 'paginations',
              name: 'Paginations',
              component: Paginations
            },
            {
              path: 'popovers',
              name: 'Popovers',
              component: Popovers
            },
            {
              path: 'progress-bars',
              name: 'Progress Bars',
              component: ProgressBars
            },
            {
              path: 'tooltips',
              name: 'Tooltips',
              component: Tooltips
            }
          ]
        },
        {
          path: 'buttons',
          redirect: '/buttons/standard-buttons',
          name: 'Buttons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'standard-buttons',
              name: 'Standard Buttons',
              component: StandardButtons
            },
            {
              path: 'button-groups',
              name: 'Button Groups',
              component: ButtonGroups
            },
            {
              path: 'dropdowns',
              name: 'Dropdowns',
              component: Dropdowns
            },
            {
              path: 'brand-buttons',
              name: 'Brand Buttons',
              component: BrandButtons
            }
          ]
        },
        {
          path: 'icons',
          redirect: '/icons/coreui-icons',
          name: 'CoreUI Icons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'coreui-icons',
              name: 'Icons library',
              component: CoreUIIcons
            },
            {
              path: 'brands',
              name: 'Brands',
              component: Brands
            },
            {
              path: 'flags',
              name: 'Flags',
              component: Flags
            }
          ]
        },
        {
          path: 'notifications',
          redirect: '/notifications/alerts',
          name: 'Notifications',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'alerts',
              name: 'Alerts',
              component: Alerts
            },
            {
              path: 'badges',
              name: 'Badges',
              component: Badges
            },
            {
              path: 'modals',
              name: 'Modals',
              component: Modals
            }
          ]
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    }
  ]

  {
          //path: '/',
          redirect: '/dashboard',
          name: 'Account',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'login',
              name: 'Login',
              component: Login
            },
            {
              path: 'register',
              name: 'Register',
              component: Register
            }
          ]
        },
}*/

